/* Country View, Vue Component */
<template>
  <v-card v-if="entity && !loading" id="country-view" class="entity-view">
      <v-card-title>View Country</v-card-title>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-row class="align-center pb-5">
        <v-col>

        <v-btn
          color="primary"
          class="me-3"
          :to="{ name: 'country-edit', params: { id: entity.Id } }"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPencilOutline }}
          </v-icon>
          <span>Edit</span>
        </v-btn>
        </v-col>
        <v-col class="text-right">
        <v-btn
          color="secondary"
          class="me-3"
          :to="{ name: 'country-list'}"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiClose }}
          </v-icon>
          <span>Cancel</span>
        </v-btn>
        </v-col>
      </v-row>
      </v-card-text>

      <v-simple-table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>

      <tr>
        <td>Name</td>
        <td>{{ entity.Name }}</td>
      </tr>

      <tr>
        <td>Code</td>
        <td>{{ entity.Code }}</td>
      </tr>

      <!-- <tr>
        <td>Postcode Validation</td>
        <td>{{ entity.PostcodeValidation }}</td>
      </tr> -->

        </tbody>
      </v-simple-table>

  </v-card>
</template>

<script>
import store from '@/store'
import { useRouter } from '@core/utils'
import * as Display from '@/datahelpers/displayTypes'

import {
  mdiPencilOutline,
  mdiClose
} from '@mdi/js'

import { ref, watch, computed } from '@vue/composition-api'

export default {
  setup() {

    const { route, router  } = useRouter();

    const entity = computed(() => store.state.app.Country);
    const loading = ref(false);

    const fetchData = (id) => {
      store
        .dispatch('app/fetchCountry', {
          id: id
        })
        .then(response => {
          loading.value = false
        })
        .catch(error => {
          console.log(error);
          router.push({ name: 'country-list'});
        })
    }

    // fetch the user information when params change
    watch(() => route.value.params.id, (id) => fetchData(id));

    // and call now
    fetchData(route.value.params.id);



    return {
      loading,
      entity,
      Display,

      icons: {
        mdiPencilOutline,
        mdiClose
      },
    };
  }
}
</script>

<style lang="scss" scoped>
.entity-view::v-deep .v-data-table th:last-child {
  width: 66%;
}
</style>

